import { Theme, styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

type StylesTypes = {
  theme?: Theme;
  isMobile: boolean;
  isLiveData?: boolean;
  isLiftStationMobile?: boolean;
  isLiftStation?: boolean;
  isSCADA?: boolean;
};

const StyledTagItem = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isMobile' &&
    prop !== 'isLiftStationMobile' &&
    prop !== 'isLiftStation' &&
    prop !== 'isSCADA',
})(({ theme, isMobile, isLiveData, isLiftStationMobile, isLiftStation, isSCADA }: StylesTypes) => ({
  display: 'flex',
  justifyContent: isSCADA ? 'flex-start' : 'space-between',
  alignItems: 'center',

  minWidth: isLiftStationMobile ? '130px' : isMobile ? '142px' : '200px',
  borderRight:
    isMobile || isLiveData || isSCADA || isLiftStation
      ? '0'
      : `1px solid ${theme?.palette.grey[300]}`,
  padding: isMobile ? '5px 6px 0 0' : '5px 12px 0 0',
  gap: isMobile ? '5px' : '10px',
  marginTop: isLiftStation ? '5px' : isLiveData ? '12px' : '',
  maxWidth: isLiftStationMobile ? '140px' : isLiftStation ? '100%' : isMobile ? '290px' : '100%',
}));

const StyledItemText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isLiftStationMobile' && prop !== 'isLiftStation',
})(({ isLiveData, isLiftStationMobile, isLiftStation }: StylesTypes) => ({
  fontSize: isLiftStationMobile ? '10px' : isLiftStation ? '13px' : '14px',
  fontWeight: isLiveData ? 'bold' : '',
  minWidth: 0,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}));

export { StyledTagItem, StyledItemText };
